import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';
import { Auth } from 'aws-amplify';

Vue.use(VueRouter);

const routes = [
  {
    path: '/cscancel',
    name: 'csCancels',
    company: 'Hippo',
    component: () => import('../views/MpCancels.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/csarchive',
    name: 'csarchive',
    company: 'Hippo',
    component: () => import('../views/MPArchiveView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/Home',
    name: 'home',
    component: () => import('../views/LandingView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: () => import('../components/templates/PdfView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/otp',
    name: 'otp',
    component: () => import('../components/templates/Otp.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/ContactUs.vue'),
    // meta: { requiresAuth: true }
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach( async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth) {
    try {
      // Check if the user is authenticated using AWS Amplify Auth
      const existingUserData = await Auth.currentAuthenticatedUser();
      // Set the values in store
      store.dispatch('setUser',existingUserData);
      store.dispatch('setAuthentication',true);
      // If the user is authenticated, allow access to the route=
      next();
      
    } catch (error) {
      console.error('error in catch data >>> ',error)
      // If the user is not authenticated, redirect to the login page
      next('/');
    }
  }
  else {
    // If the route does not require authentication, allow access
    next();
  }
});

export default router;
